import React from "react"
import { Link } from "react-router-dom"
import RegisterComponent from "./RegisterComponent"

import "../login/LoginComponent.sass"

function RegisterComponentWrapper() {
  return (
    <>
      <div id="register-wrapper">
        <RegisterComponent />
      </div>
    </>
  )
}

export default RegisterComponentWrapper
